import { ReportsApiBase } from './paymentApi';

class ReportsApi extends ReportsApiBase {
}

export default new ReportsApi();
